import React, { createContext, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import HomeService from '../services/HomeService';

const WarningContext = createContext();

export const useWarning = () => useContext(WarningContext);

export const WarningProvider = ({ children, isLoggedIn }) => {
  const [warningMessage, setWarningMessage] = useState("");
  const location = useLocation();

  useEffect(() => {
    if (!isLoggedIn) return;

    const fetchWarning = async () => {
      try {
        const res = await HomeService.getWarningMessage();
        const messageData = res?.data?.result;

        if (messageData?.isActive) {
          setWarningMessage(messageData.message);
        } else {
          setWarningMessage("");
        }
      } catch (err) {
        console.error("Error fetching warning:", err);
        setWarningMessage(""); // optional: reset on error
      }
    };

    fetchWarning(); // fetch on mount and route change
  }, [location.pathname, isLoggedIn]);

  return (
    <WarningContext.Provider value={{ warningMessage }}>
      {children}
    </WarningContext.Provider>
  );
};
